import history from '../history'

const changeLocation = (localization) => {
  history.push(localization)
}

export default changeLocation
